export default __webpack_public_path__ + "static/media/thankful.9b25069e.svg";